export default {"src":"/_next/static/media/getting-started-boat.mono.762c0bda.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};